import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import MenuList from '../../../components/Shop/ManageMenu/ManageList/MenuList'
import Loader from '../../../components/Common/Loader/Loader';

import getAllMenuQuery from './getAllMenu.graphql';

import s from './Category.css';
class Category extends React.Component {

  static defaultProps = {
    menuDetails: {
      loading: true
    }
  }

  render() {
    const { menuDetails, menuDetails: { loading } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            {!loading && <MenuList menuDetails={menuDetails} />}
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllMenuQuery, {
    name: 'menuDetails',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchList: ''
      }
    }
  })
)(Category);
